var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ManageProductList',{ref:"productList"})
}
var staticRenderFns = []

export { render, staticRenderFns }